export default {
      id: "icon-bool-include-usage",
      viewBox: "0 0 17 14",
      url: "/" + "assets/sprite.svg#icon-bool-include",
      toString: function () {
        return this.url;
      }
    }